export function normalizeText(value) {
    return String(value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
}

export function accentInsensitiveFilter(item, queryText, itemText) {
    return normalizeText(itemText).includes(normalizeText(queryText))
}

export function highlightParts(text, query) {
    const value = String(text ?? ''),
        needle = normalizeText(query)

    if (!needle) {
        return [{text: value, match: false}]
    }

    // Normalize char by char so indexes stay aligned with the original text
    let normalized = '',
        map = []

    Array.from(value).forEach((char, index) => {
        const normalizedChar = char.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        for (let i = 0; i < normalizedChar.length; i++) {
            map.push(index)
        }
        normalized += normalizedChar
    })

    const chars = Array.from(value),
        index = normalized.indexOf(needle)

    if (index < 0) {
        return [{text: value, match: false}]
    }

    const startChar = map[index],
        endChar = map[index + needle.length - 1] + 1,
        parts = [
            {text: chars.slice(0, startChar).join(''), match: false},
            {text: chars.slice(startChar, endChar).join(''), match: true},
            {text: chars.slice(endChar).join(''), match: false}
        ]

    return parts.filter(part => part.text !== '')
}
